//import '../../MissionControl/PluginManager.css';
import React, { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import {
    ListGroup, 
    ListGroupItem,
    Row,
} from 'reactstrap';
import moment from 'moment';
import hasPermission from '../../../Shared/hasPermission';

const PluginOfferingList = ({
    offeringName, 
    pluginsOffering, 
    button, 
    loading, 
    lockbutton, 
    locked,
    refreshBitwerxOffering
}) => {
    const [removing, setRemoving] = useState(false);
    const { permissions } = useSelector((state) => ({
        permissions: state.auth.permissions,
    }), shallowEqual);
    const dispatch = useDispatch();

    const handleRemovePlugin = async (pluginId) => {
        setRemoving(true);
        try {
            await dispatch(actions.missionControl.removePluginFromOffering(pluginId, offeringName));
            refreshBitwerxOffering();
        } catch (error) {
            console.error("Error removing the plugin:", error);
        } finally {
            setRemoving(false);
        }
    };

    const canAddPluginOffering = hasPermission(['BitwerxOfferingPluginManagerEdit'], permissions);

    return (
        <Row className="sc-glass shadow text-light sc-rounded px-2 py-4 mb-4">
            <>
                <div className="col-12 col-md-12 col-lg-12 mb-2">
                    <div className="d-flex justify-content-between mb-4">
                        <div>
                            <h3>{offeringName ? offeringName + ' - ' : ''} Plugin Management</h3>
                        </div>
                        {canAddPluginOffering && (
                            lockbutton
                        )}
                    </div>

                    {loading === true ? (
                        <div className="loading-spinner spin-animate mx-auto my-4"></div>
                    ) : (
                        <ListGroup
                            style={{
                                maxHeight: '60vh',
                                overflowY: 'scroll',
                            }}>
                            {pluginsOffering?.data?.map((p) => (
                                <div key={p.id} className={'text-dark offering-plugin-container'}>
                                    <ListGroupItem>
                                        <div className="row">
                                            <div className="col-12 col-md-12 col-lg-6">
                                                <div className="mt-1 text-muted">
                                                    <p className="text-sm offering-plugin-field">
                                                        Plugin Name
                                                        <b className="d-block">
                                                            {p.name}
                                                        </b>
                                                    </p>
                                                    <p className="text-sm offering-plugin-field">
                                                        <span>Default Version </span><br />
                                                        {p?.defaultPluginVersion?.version ? <strong>{p?.defaultPluginVersion?.version}</strong> : '(not available)'}
                                                        
                                                    </p>
                                                    {p?.defaultPluginVersion?.releaseDate && (
                                                        <>
                                                            <p className="text-sm offering-plugin-field">
                                                                <span>Release Date </span><br />
                                                                <strong>{moment(p?.defaultPluginVersion?.releaseDate).format('M/D/YYYY')}</strong>
                                                            </p>
                                                        </>
                                                    )}
                                                    {p?.defaultPluginVersion?.description && (
                                                        <>
                                                            <p className="text-sm offering-plugin-field">
                                                                <span>Description </span><br />
                                                                <strong>{p?.defaultPluginVersion?.description}</strong>
                                                            </p>                                                    
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-12 col-lg-6">
                                                    <h5 className="mt-1 text-muted">
                                                    Plugin Dependencies:
                                                </h5>
                                                    <ul className="list-unstyled">
                                                    {p?.pluginDependencies.map(
                                                        (d) => (
                                                            <li key={d.id}>
                                                                    <p>{d?.plugin.name}</p>
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                                    <h5 className="mt-3 text-muted">
                                                    Supported Pims Dependencies:
                                                </h5>
                                                    <ul className="list-unstyled">
                                                    {p?.pimsDependencies.map(
                                                        (d) => (
                                                            <li key={d.id}>
                                                                    <p>{d.pims}{d?.pimVersion ? `\xa0 Version: ${d?.pimVersion}`: ''}</p>
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </div>
                                            {!locked && (
                                                <div className="offering-plugin-trash-icon">
                                                    {/* NOTE: removing will apply to ALL remove buttons AND the add button to prevent accidental operations */}
                                                    <FontAwesomeIcon 
                                                        icon={faTrash} 
                                                        onClick={removing ? null : () => handleRemovePlugin(p.id)}
                                                        className={removing ? "offering-plugin-trash-icon-removing" : ""}
                                                    />
                                                </div>
                                            )}                                        
                                            
                                        </div>
                                    </ListGroupItem>
                                </div>
                            ))}
                        </ListGroup>
                    )}
                </div>
                {canAddPluginOffering && !loading && !locked && (
                    <div className="col-12 col-md-12 mt-2 d-flex justify-content-between offering-plugin-add-button">
                        <div className={removing ? 'offering-plugin-add-button-disabled' : ''}>
                            {button}
                        </div>
                    </div>
                )}
            </>
        </Row>
    );
};

const getVersionDescription = (description) => {

    if (description) {
        if (description.length > 50)
            return description.substring(0, 50) + '...'

        return description
    }

    return ''
}

export default PluginOfferingList;
